export default __webpack_public_path__ + "static/media/Spin general_Interactive LightMix0046.8f5a6de3.webp";